import { useParams } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import { Avatar, Chip } from "@material-ui/core";
import QueueTableActions from "./components/table-action";
import SearchField from "../../../../../../../../../components/search-field";
import { useAttendanceLocalDepartmentQueueList } from "../../../../../../../../../../../services/api-tansquery/attendance-local/department/queue/list";
import { useAttendanceLocalStyles } from "../../../../../../../../../styles";
import { useListTabPanelStyles } from "./styles";
import EmptyState from "../../../../../../../../../../../Components/EmptyState";
import QueueFormCreate from "../form/create";
import { useMemo } from "react";
import { dateformat } from "../../../../../../../../../../../utils/dateFormat";

export default function ListTabPanel() {
    const { slug, id } = useParams<{ slug: string, id: string }>();
    const { classes } = useListTabPanelStyles();
    const { classes: defaultClasses } = useAttendanceLocalStyles();
    const { data: queues } = useAttendanceLocalDepartmentQueueList({ setor: Number(id) });

    const isEmpty = useMemo(() => (
        (queues?.results ?? []).length === 0
    ), [queues]);

    return (
        <Paper elevation={3}>
            <Box className={classes.header}>
                <Box className={classes.search}>
                    <SearchField placeholder="Buscar criador" />
                </Box>
                <QueueFormCreate slug={slug} departmentId={Number(id)} />
            </Box>
            <TableContainer className={defaultClasses.tableContainer}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={defaultClasses.tableTH}>Início</TableCell>
                            <TableCell className={defaultClasses.tableTH}>Fim</TableCell>
                            <TableCell className={defaultClasses.tableTH}>Configuração</TableCell>
                            <TableCell className={defaultClasses.tableTH}>Criado por</TableCell>
                            <TableCell className={defaultClasses.tableTH} />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {queues?.results.map((queue) => (
                            <TableRow
                                hover
                                key={`queue-${queue.id}`}
                                role="checkbox"
                                tabIndex={-1}
                            >
                                <TableCell className={defaultClasses.tableCell}>
                                    {dateformat(queue.data_inicio)}
                                </TableCell>
                                <TableCell className={defaultClasses.tableCell}>
                                    {dateformat(queue.data_fim)}
                                </TableCell>
                                <TableCell className={defaultClasses.tableCell}>
                                    <Box className={classes.chipsBox}>
                                        {queue.sabado && (
                                            <Chip label="Incluir sábado" />
                                        )}
                                        {queue.domingo && (
                                            <Chip label="Incluir domingo" />
                                        )}
                                        {queue.ignorar_feriados && (
                                            <Chip label="Ignorar feriados" />
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell className={defaultClasses.tableCell}>
                                    <Box className={classes.userBox}>
                                        <Avatar />
                                        {queue.user.first_name}
                                    </Box>
                                </TableCell>
                                <TableCell align="right" className={defaultClasses.tableCell}>
                                    <QueueTableActions queue={queue} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                {isEmpty && <EmptyState message="Nenhuma fila encontrada." />}
            </TableContainer>
        </Paper>
    );
}
